import React, { useState } from 'react';
import { Heart } from 'lucide-react';

const CompanyCard = ({ company, isFavorite, onToggleFavorite, contextLabel, avatarStyle, onClick }) => {
    return (
        <div
            className="bg-white border border-gray-100 rounded-[20px] p-5 hover:shadow-lg hover:border-blue-100 transition-all group cursor-pointer relative flex flex-col justify-between h-full min-h-[160px]"
            onClick={() => onClick && onClick(company)}
        >

            {/* Top section: Avatar + Name + Heart */}
            <div className="flex items-start gap-4">
                {/* Avatar */}
                {avatarStyle && (
                    <div className={`w-12 h-12 rounded-xl ${avatarStyle.bg} flex items-center justify-center flex-shrink-0 transition-transform group-hover:scale-105`}>
                        <span className={`${avatarStyle.text} font-bold text-lg`}>
                            {company.name ? company.name.charAt(0).toUpperCase() : '?'}
                        </span>
                    </div>
                )}

                {/* Name & Context */}
                <div className="flex-1 min-w-0 pt-0.5">
                    <h3 className="text-base font-black text-slate-900 tracking-tight truncate leading-tight group-hover:text-blue-600 transition-colors">
                        {company.name}
                    </h3>
                    <div className="mt-1 text-[11px] font-bold text-slate-400 uppercase tracking-wider">
                        {contextLabel || 'Global'}
                    </div>
                </div>

                {/* Heart Icon */}
                <button
                    onClick={(e) => {
                        e.stopPropagation();
                        onToggleFavorite(company.name);
                    }}
                    className="p-1.5 -mr-2 -mt-2 hover:bg-slate-50 rounded-full transition-all group/heart"
                    title={isFavorite ? "Retirer des favoris" : "Ajouter aux favoris"}
                >
                    <Heart
                        className={`w-5 h-5 transition-all duration-300 ${isFavorite
                            ? 'fill-blue-500 text-blue-500 scale-110'
                            : 'fill-transparent text-slate-300 group-hover/heart:text-blue-500'
                            }`}
                    />
                </button>
            </div>

            {/* Separator */}
            <div className="border-t border-slate-50 my-4"></div>

            {/* Bottom Row: Offres diponibles + Stats */}
            <div className="flex items-center justify-between">
                <span className="text-xs font-semibold text-slate-400">Offres disponibles</span>

                <div className="flex items-center gap-3">
                    <div className="flex flex-col items-center">
                        <span className="text-[9px] font-bold text-slate-300 uppercase mb-0.5">Actifs</span>
                        <span className="px-2.5 py-0.5 bg-blue-50 text-blue-600 rounded-md font-black text-sm">
                            {company.active}
                        </span>
                    </div>
                    <div className="flex flex-col items-center">
                        <span className="text-[9px] font-bold text-slate-300 uppercase mb-0.5">Total</span>
                        <span className="px-2.5 py-0.5 bg-violet-50 text-violet-600 rounded-md font-black text-sm">
                            {company.total}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CompanyCard;
